import globalApi from '../../api'

export const getAssignedComplaintListApi = ({ filter }) => 
  globalApi.post('/Complaint/GetAssignedComplaintList', {...filter, isSecured: true })

export const assignComplaintApi = ({ complaintId, intervenorId }) =>
globalApi.post('/Complaint/AssignComplaint', { 
  complaintId,
  intervenorId,
  isSecured: true,
})

export const uploadImageApi = (formData) => 
globalApi.post('/Aws/UploadImage', formData,
{ isSecured: true })

export const returnComplaintApi = ({complaintId, comment}) => 
globalApi.post('/Complaint/ReturnComplaint', {
  complaintId,
  comment,
  isSecured: true,
})

export const startProcessingComplaintApi = ({complaintId, timeLimit}) => 
globalApi.post('/Complaint/StartProcessingComplaint', {
  complaintId,
  timeLimit,
  isSecured: true,
})

export const processedComplaintApi = (complaintId, pictureLink) => 
  globalApi.post('/Complaint/ProcessedComplaint', {
    complaintId,
    pictureLink,
    isSecured: true,
  })


export const getTrashTypesApi = () =>
  globalApi.get('/Complaint/TrashTypes', { isSecured: true })

export const getNaturesApi = () =>
  globalApi.get('/Complaint/Natures', { isSecured: true })
// export const getStatusesApi = () =>
//   globalApi.get('/Complaint/Statuses', { isSecured: true })

// export const changeComplaintStatusApi = ({ complaintId, statusType }) =>
//   globalApi.put('/Complaint/StatusChange', {
//     complaintId,
//     statusType,
//     isSecured: true,
//   })
export const assignComplaintStatusApi = ({ complaintId, statusType }) => 
  globalApi.put(`/Complaint/statusChange?complaintId=${complaintId}`, {
    complaintId,
    statusType,
    isSecured: true,
  })
export const resetComplaintStatusApi = ({ id }) =>
  globalApi.put(`/Complaint/StatusReset?complaintId=${id}`, {
    isSecured: true,
  })
export const getComplaintOperationListApi = ({ complaintId, take, skip }) =>
  globalApi.post('/Complaint/GetComplaintOperationList', {
    complaintId,
    take: take,
    skip: skip,
    isSecured: true,
  })